export enum CardType {
  UZCARD = 'uzcard',
  HUMO = 'humo',
  MASTERCARD = 'mastercard',
  VISA = 'visa',
}

export interface ICardList {
  id: number;
  last_numbers: string;
  title: string;
  ps: CardType;
}
export interface ISaveCard {
  id: number;
  otp: string;
}
